import { Fragment, useEffect } from 'react'
import { fattPayClient } from "./FattPayClient";
import { Col, Form, Row } from 'react-bootstrap';
import Payment, { BankHolderType, BankType } from './Payment';
import { deepCopy } from '../../Components/Shared/Utility/DeepCopy';

interface IProps {
    onPaymentChanged: (payment: Payment) => void;
    payment: Payment,
    disabled?: boolean
}

export const FattPayBank = (props: IProps) => {
    useEffect(() => {
        async function initialize() {
            //Initialize Bank
            await fattPayClient.initializeBank();
        }
        initialize();
    }, []);

    const updateAccountNumber = (accountNumber: string) => {
        const updated = deepCopy(props.payment);
        updated.accountNumber = accountNumber;
        props.onPaymentChanged(updated);
    }
    const updateRoutingNumber = (routingNumber: string) => {
        const updated = deepCopy(props.payment);
        updated.routingNumber = routingNumber;
        props.onPaymentChanged(updated);
    }
    const updateBankType = (type: BankType) => {
        const updated = deepCopy(props.payment);
        updated.bankType = type;
        props.onPaymentChanged(updated);
    }
    const updateBankHolderType = (type: BankHolderType) => {
        const updated = deepCopy(props.payment);
        updated.bankHolderType = type;
        props.onPaymentChanged(updated);
    }

    return (
        <Fragment>
            <Form.Group className="mt-4">
                <Form.Row>
                    <Col xs={12} md={5} lg={6}>
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Account Number
                            <span className="text-pp-primary ml-2">*</span></Form.Label>
                        <Form.Control type="input" required
                            onChange={(e) => updateAccountNumber(e.target.value)}
                            defaultValue={props.payment.accountNumber} />
                        <span className="invalid-feedback">Account Number is Required</span>

                    </Col>
                </Form.Row>
            </Form.Group>
            <Form.Group className="mt-4">
                <Form.Row>
                    <Col xs={12} md={5} lg={6}>

                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Routing Number
                            <span className="text-pp-primary ml-2">*</span></Form.Label>
                        <Form.Control type="input" required style={{ height: "calc(1.5em + 0.75rem + 2px)" }}
                            onChange={(e) => updateRoutingNumber(e.target.value)}
                            defaultValue={props.payment.routingNumber} />
                        <Form.Control.Feedback type="invalid">Routing Number is Required</Form.Control.Feedback>
                    </Col>
                </Form.Row>
            </Form.Group>
            <Form.Group controlId="bankType">
                <Row>
                    <Col xs={4} md={5} lg={4}>
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Type<span className="text-pp-primary ml-2">*</span></Form.Label>
                        <Form.Check
                            type="radio"
                            label="Checking"
                            formNoValidate={true}
                            checked={props.payment.bankType == BankType.checking}
                            onChange={() => updateBankType(BankType.checking)}
                            className="ml-1 mt-3" />
                    </Col>
                    <Col xs={4} md={5} lg={4}>
                        <Form.Label></Form.Label>
                        <Form.Check
                            type="radio"
                            formNoValidate={true}
                            label="Savings"
                            checked={props.payment.bankType == BankType.savings}
                            onChange={() => updateBankType(BankType.savings)}
                            className="ml-1 mt-3" />
                    </Col>
                </Row>
            </Form.Group>
            <Form.Group controlId="bankHolderType">
                <Row>
                    <Col xs={4} md={5} lg={4}>
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Purpose<span className="text-pp-primary ml-2">*</span></Form.Label>
                        <Form.Check
                            type="radio"
                            label="Personal"
                            checked={props.payment.bankHolderType == BankHolderType.personal}
                            onChange={() => updateBankHolderType(BankHolderType.personal)}
                            className="ml-1 mt-3" />
                    </Col>
                    <Col xs={4} md={5} lg={4}>
                        <Form.Label></Form.Label>
                        <Form.Check
                            type="radio"
                            label="Business"
                            checked={props.payment.bankHolderType == BankHolderType.business}
                            onChange={() => updateBankHolderType(BankHolderType.business)}
                            className="ml-1 mt-3" />
                    </Col>
                </Row>
            </Form.Group>
        </Fragment>);
}